export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_night_353.71fae45f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};